import { fetchChainRequest } from "actions";
import BBAPrice from "assets/img/icons/bba.png";
import ProgressIcon from "assets/img/icons/progress.png";
import classNames from "classnames";
import Widget from "components/widget/Widget";
import { useEffect } from "react";
import { BiSolidNotepad } from "react-icons/bi";
import { IoMdSettings } from "react-icons/io";
import { MdLocalGasStation } from "react-icons/md";
import { RiGlobalFill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "reducers";
import { AppDispatch } from "store";
import { formatNumber, NetworkFee } from "utils";

const NetworkStatus = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { chain } = useSelector((state: RootState) => state.chain);
  const { price } = useSelector((state: RootState) => state.price);

  useEffect(() => {
    dispatch(fetchChainRequest());
  }, [dispatch]);

  // if (loading) return <>{/* TODO: skeleton view */}</>;
  // if (error) return <p>Error: {error}</p>;

  return (
    <div className="box z-10 mb-4 grid grid-cols-1 gap-6 overflow-hidden bg-white px-2.5 py-5 dark:border-darkPrimary dark:!bg-darkPrimary md:grid-cols-2 md:px-5 md:py-5 lg:col-span-2 lg:grid-cols-3 xl:mb-0">
      <Widget
        icon={<RiGlobalFill className="h-7 w-7" />}
        title={"Market Cap"}
        subtitle={
          <span>${formatNumber(price.fully_diluted_market_cap, 0)}</span>
        }
      />

      <Widget
        icon={<img className="h-7 w-7" src={BBAPrice} alt="BBA Price" />}
        title={"BBA Price (24h)"}
        subtitle={
          <span>
            ${formatNumber(price.price)}{" "}
            <span
              className={classNames(
                price.percent_change_24h > 0 ? "text-green-600" : "text-red-500"
              )}
            >
              ({price.percent_change_24h > 0 && "+"}
              {price.percent_change_24h.toFixed(2)}%)
            </span>
          </span>
        }
      />

      <Widget
        icon={<IoMdSettings className="h-7 w-7" />}
        title={"Volume (24h)"}
        subtitle={<span>${formatNumber(price.volume_24h, 0)}</span>}
      />
      <Widget
        icon={<MdLocalGasStation className="h-7 w-7" />}
        title={"Fee Price"}
        subtitle={<span>${formatNumber(NetworkFee * price.price, 6)}</span>}
      />
      <Widget
        icon={<BiSolidNotepad className="h-7 w-7" />}
        title={"Transactions"}
        subtitle={
          <span>
            {formatNumber(chain.transaction_count)}
            {/* <span className="text-green-600">(+62.54%)</span> */}
          </span>
        }
      />
      <Widget
        icon={<img className="h-6 w-6" src={ProgressIcon} alt="" />}
        title={"Latest Block"}
        subtitle={<span>{formatNumber(chain.block_height)}</span>}
      />
    </div>
  );
};

export default NetworkStatus;
